import { render, staticRenderFns } from "./exit.vue?vue&type=template&id=0138876b"
import script from "./exit.vue?vue&type=script&lang=js"
export * from "./exit.vue?vue&type=script&lang=js"
import style0 from "./exit.vue?vue&type=style&index=0&id=0138876b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports